import React, { useContext } from "react";
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain_Bus from './../DashboardMain_Bus/DashboardMain_Bus';
import AppContext from '../../../store/AppContext';
import { useState } from "react";

function GlossaryPage_Bus() {
    const app_ctx = useContext(AppContext);
    return (
        <>
            <DashboardMain_Bus>
                <body style={{ backgroundColor: "white" }}>
                    <h1 style={{ fontWeight: 'bold', marginLeft: "2em", marginTop: "1em", fontSize: "2em" }} align="center">Glossary Page<Link to="/dashboard_bus/driveanalysis_bus" style={{ color: "rgb(131, 164, 207)", marginLeft: "5%", fontSize: '0.7em' }}><BsSkipBackwardCircleFill /></Link></h1>
                    <table className="table table-hover tableglosary" style={{ width: "50%", height: "20%" }} align="center">
                        <thead style={{ backgroundColor: 'rgb(131, 164, 207)', color: '#fff' }}>
                            <tr>
                                <th scope="col">Sr.No.</th>
                                <th scope="col">KPI name</th>
                                <th scope="col">Business Logics</th>
                                <th scope="col">Backend Formula</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Vehicle Count
                                </td>
                                <td>Count of Vehicle Chassis for seleted date range
                                </td>
                                <td>Distinct Count (VIN)
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Discharge Cycles
                                </td>
                                <td>Count of discharge cycles for seleted date range & Chassis
                                </td>
                                <td>Count (number of discharge cycles)
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Total Km travelled
                                </td>
                                <td>Sum of distance travelled by all Vehicle Chassis for seleted date range
                                </td>
                                <td>Sum (ODO value of all vehicles)
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Discharge
                                </td>
                                <td>Start Soc minus End Soc
                                </td>
                                <td>SocStart - SocEnd
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Median Range (km)
                                </td>
                                <td>Median of Range in all discharge cycles of all vehicles
                                </td>
                                <td>Median ((Distance/Discharge) *80)
                                </td>
                            </tr>

                            <tr>
                                <td>6</td>
                                <td>Median KWh/km
                                </td>
                                <td>Median of KWh/km of all discharge cycles of all vehicles
                                </td>
                                <td>Median (Net kWh/DistTravelled)
                                </td>
                            </tr> <tr>
                                <td>7</td>
                                <td>Median discharge duration
                                </td>
                                <td>Median of Discharge cycles of all vehicles
                                </td>
                                <td>Median (Start Time - End time)
                                </td>
                            </tr>

                            <tr>
                                <td>8</td>
                                <td>Average Discharge/Cycle (% SoC)

                                </td>
                                <td>Median of discharge Soc for all cycles
                                </td>
                                <td>Median (SocStart - SocEnd)
                                </td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Median Consumption/Cycle (kWh
                                </td>
                                <td>Median of Net kwh in all discharge cycles
                                </td>
                                <td>Median ((A_KWh_Remain+B_KWh_Remain+C_KWh_Remain+D_KWh_Remain)@start of discharge - (A_KWh_Remain+B_KWh_Remain+C_KWh_Remain+D_KWh_Remain)@end of discharge)
                                </td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>Delta DTE
                                </td>
                                <td>Distance_to_Empty (@ End of discharge - @ Start of discharge) for all discharge cycles
                                </td>
                                <td>Distance_to_Empty (Start - End)
                                </td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>Error DTE
                                </td>
                                <td>(Detla DTE minus distance travelled * 100 )divided by distance travelled
                                </td>
                                <td>(Delta DTE - distTrav) *100/distTrav
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </body>
            </DashboardMain_Bus>
        </>
    );
}

export default GlossaryPage_Bus;
